import React from 'react';
import { Hero } from '../components/Hero';
import { Services } from '../components/Services';
import { About } from '../components/About';
import { Process } from '../components/Process';
import { Testimonials } from '../components/Testimonials';
import { Results } from '../components/Results';
import { Contact } from '../components/Contact';
export function Home() {
  return <>
      <Hero data-id="element-328" />
      <Services data-id="element-329" />
      <About data-id="element-330" />
      <Process data-id="element-331" />
      <Results data-id="element-332" />
      <Testimonials data-id="element-333" />
      <Contact data-id="element-334" />
    </>;
}